import {PayloadAction} from '@reduxjs/toolkit';
//types
import {
	IOrganizationAuctionCategory,
	IOrganizationAuctionListResponse,
	IOrganizationAuctionReducer,
	IOrganizationAuctionResponse,
	IOrganizationAuctionWonListResponse,
} from '../../utils/types';

export const pendingOperation = (state: IOrganizationAuctionReducer) => {
	state.isLoading = true;
};

export const rejectedOperation = (state: IOrganizationAuctionReducer) => {
	state.isLoading = false;
};

export const getAuctionListOperation = (
	state: IOrganizationAuctionReducer,
	{payload}: PayloadAction<IOrganizationAuctionListResponse>
) => {
	state.auctionList = payload;
	state.isLoading = false;
};

export const getAuctionCategoriesOperation = (
	state: IOrganizationAuctionReducer,
	{payload}: PayloadAction<IOrganizationAuctionCategory[]>
) => {
	state.auctionCategories = payload;
	state.isLoading = false;
};

export const clearAuctionDataOperation = (
	state: IOrganizationAuctionReducer,
	initialState: IOrganizationAuctionReducer
) => {
	state.auctionList = initialState.auctionList;
	// Object.assign(state, initialState);
};

export const getAuctionOperation = (
	state: IOrganizationAuctionReducer,
	{payload}: PayloadAction<IOrganizationAuctionResponse>
) => {
	state.auction = payload;
	state.isLoading = false;
};

export const getAuctionWonListOperation = (
	state: IOrganizationAuctionReducer,
	{payload}: PayloadAction<IOrganizationAuctionWonListResponse>
) => {
	state.auctionWonList = payload;
	state.isLoading = false;
};
